import type { IAdvancedFilters, IASOAdvanced, IASOKeyword } from '~/types/aso'

import config from '~/config'
import { request } from '~/utils/request'

export const getASOKeywordsAdvanced = ({
  appId,
  filters,
}: {
  appId: string
  filters: IAdvancedFilters
}): Promise<IASOAdvanced> => {
  return request({
    data: filters,
    method: 'POST',
    url: `${config.VERSIONS_API}/application/${appId}/aso/advanced`,
  })
}

export const getASOKeywordsOverview = (appId: string): Promise<IASOKeyword[]> => {
  return request({
    url: `${config.VERSIONS_API}/application/${appId}/aso/overview`,
  })
}

export const markAsBrand = ({
  brand,
  markAsBrand,
  owned,
}: {
  brand: string
  markAsBrand: boolean
  owned: boolean
}): Promise<void> => {
  return request({
    data: {
      brand,
      owned,
      valid: markAsBrand,
    },
    method: 'POST',
    url: `${config.VERSIONS_ADMIN}/brand`,
  })
}
